// extracted by mini-css-extract-plugin
module.exports = {"icon-composition":"icon-composition___3p60E","ep-app-icon":"ep-app-icon___YyRML","instruction":"instruction___HvZi7","download-icon":"download-icon___eSyEy"};